<template>
    <div class="ww_elec_maintain">
        <div style="margin-bottom: 20px;">
            <el-form
                :label-position="'left'"
                :model="searchForm"
                ref="searchForm"
                class="leader-style-form"
                :inline="true"
            >
                <el-form-item label="区域" prop="area_name">
                    <el-input
                        v-model="searchForm.area_name"
                        maxlength="200"
                        clearable
                    ></el-input>
                </el-form-item>
                <!-- <el-form-item label="类型" prop="microgrid_catalog_type">
                    <el-select
                        style="width: 100%"
                        v-model="searchForm.microgrid_catalog_type"
                        placeholder="请选择类型"
                    >
                        <el-option
                            v-for="item in catalogTypes"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value"
                        ></el-option>
                    </el-select>
                </el-form-item> -->

                <div style="float: right">
                    <el-button
                        size="medium"
                        type="warning"
                        @click="getAreaPriceList"
                        >查询</el-button
                    >
                    <!-- <el-button type="primary" @click="addNewData" size="medium"
                        >新增</el-button
                    > -->
                </div>
            </el-form>
        </div>
        <div class="table-wrap">
            <el-scrollbar style="height: 90%">
                <el-table border :data="tableData" class="leader-style-table">
                    <el-table-column label="序号" width="50" align="center">
                        <template slot-scope="scope">
                            <span>
                                {{
                                    scope.$index + 1
                                }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="区号"
                        prop="area_id"
                    ></el-table-column>
                    <el-table-column
                        label="区域"
                        prop="area_name"
                    ></el-table-column>
                    <!-- <el-table-column
                        label="目录电价名称"
                        prop="microgrid_catalog_iname"
                    ></el-table-column>
                    <el-table-column
                        label="类型"
                        prop="microgrid_catalog_type_name"
                    ></el-table-column> -->
                    <el-table-column label="操作" align="center" width="210">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                @click="handleEditDJ(scope.row)"
                                >电价</el-button
                            >
                            <!-- <el-button
                                type="text"
                                @click="handleEditInfo(scope.row, '修改')"
                                >修改</el-button
                            >
                            <el-button
                                type="text"
                                @click="hanleDelInfo(scope.row)"
                                >删除</el-button
                            > -->
                            <!-- <el-button
                                type="text"
                                @click="handleEditInfo(scope.row, '查看')"
                                >查看</el-button
                            > -->
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>

            <!-- <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination> -->
        </div>
        <el-dialog
            class="leader-dialog"
            title="电价维护"
            width="40%"
            :visible.sync="djDialogStatus"
            @close="closeDjDialog"
            :close-on-click-modal="false"
        >
            <el-form
                :model="djForm"
                ref="djForm"
                :rules="djFormRules"
                label-width="200px"
                class="leader-style-form"
            >
                <div class="caculate-wrap">
                    <el-row v-for="(item, index) in expressionList" :key="index">
                        <div class="point_date">
                            <el-col :span="2">
                            
                                <el-radio
                                    v-model="curIndex"
                                    :label="item.microgrid_catalog_price_id"
                                    @change="changeDateRadio"
                                    >{{ "" }}</el-radio
                                >
                            </el-col>
                            <el-col :span="8">
                            
                                <el-date-picker
                                    v-model="item.from_date"
                                    type="month"
                                    value-format="yyyy-MM"
                                    placeholder="开始日期"
                                ></el-date-picker>
                            </el-col>
                            <el-col :span="8">
                                
                                <el-date-picker
                                    v-model="item.to_date"
                                    type="month"
                                    placeholder="结束日期"
                                    value-format="yyyy-MM"
                                    style="margin-left: 1rem;"
                                ></el-date-picker>
                            </el-col>
                            <el-col :span="3">
                                <el-button
                                    class="leader-common-button elec_price_btn"
                                    size="small"
                                    @click="doAddDate(index + 1)"
                                    v-if="index == expressionList.length - 1"
                                    >+</el-button
                                >
                            </el-col>
                            
                            <el-col :span="3">
                                <el-button
                                    class="leader-common-button elec_price_btn_minus"
                                    size="small"
                                    @click="
                                        doMinusDate(
                                            item.microgrid_catalog_price_id,
                                            index
                                        )
                                    "
                                    v-if="
                                        index > 0 &&
                                            index == expressionList.length - 1
                                    "
                                    >-</el-button
                                >
                            </el-col>
                        </div>
                    </el-row>
                    <div style="margin-top: 1rem; width: 90%">
                        <el-form-item label="容量电价（元/kWh）" label-width="160px" prop="capacity_price">
                            <el-input
                                v-model="djForm.capacity_price"
                                placeholder="请输入尖电价"
                                maxlength="10"
                            ></el-input>
                        </el-form-item>
                        
                        
                        <el-form-item label="需量电价（元/kWh）" label-width="160px" prop = "demand_price">
                            <el-input
                                v-model="djForm.demand_price"
                                placeholder="请输入峰电价"
                                maxlength="10"
                            ></el-input>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">  
                <el-button
                    class="leader-common-button"
                    @click="addDjCommit"
                    v-if="dialogTitle != '查看'"
                    >保 存</el-button
                >
                 <el-button @click="closeDjDialog" class="leader-common-button"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
export default {
    data() {
        return {
            inputValue: '',
            searchForm: {
              //  microgrid_catalog_type: "",
                area_name: ""
            },
            catalogTypes: [],
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            tableData: [],
            dialogTitle: "新增",
            dialogStatus: false,
            djDialogStatus: false,
            formData: {
                microgrid_catalog_id: "",
                microgrid_catalog_iname: "", // 目录电价名称
                elec_customer_id: "", //公司id
                microgrid_catalog_type: "" //类型
            },
            formDataRule: {
                elec_customer_id: [
                    {
                        required: true,
                        message: "请选择公司",
                        trigger: "blur"
                    }
                ],
                microgrid_catalog_iname: [
                    {
                        required: true,
                        message: "请输入目录电价名称",
                        trigger: "blur"
                    }
                ],
                microgrid_catalog_type: [
                    {
                        required: true,
                        message: "请输入类型",
                        trigger: "blur"
                    }
                ]
            },
            companys: [], //公司列表
            pointSelects: [],
            oldCurIndex: 0,
            curIndex: 0,
            djForm: {
                capacity_price: "",
                demand_price: "",
            },
            djFormRules:{
                capacity_price:[
                    {
                        required: true,
                        validator:this.validPrice,
                        trigger:"blur"

                    }
                ],
                demand_price:{
                    required:true,
                    validator:this.validPrice,
                    trigger: "blur"
                }
            },
            expressionList: [
                {
                    area_id: "",
                    area_name: '',
                    capacity_price: "",
                    demand_price: "",
                    from_date: null,
                    to_date: null,
                }
            ],
            curRow: null,
        };
    },
    created() {
        this.getAreaPriceList();
    },
  
    methods: {
        validPrice(rule, value, callback) {
            // 使用正则表达式来判断输入是否合法 /^-?\d+(\.\d+)?$/
            const regex = /^-?\d+(\.\d+)?$/;
            if(value === ''){
                callback(new Error('请输入电价'));
            }else if(!regex.test(value)){
                callback(new Error('要求必须为数值类型'))
            }else {
                callback();
            }
        },
        getAreaPriceList() {
            api.getAreaPriceList({
                ...this.searchForm,
                // pageNum: this.pageNum,
                // pageSize: this.pageSize
            }).then(res => {
                if (res && res.error_code === "0") {
                    {
                        this.tableData = res.bus_json;
                      //  this.totalNum = res.bus_json.totalNum;
                    }
                }
            });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getAreaPriceList();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getAreaPriceList();
        },
        addNewData() {
            this.dialogTitle = "新增";
            this.dialogStatus = true;
            this.formData.microgrid_catalog_id = "";
            this.formData.elec_customer_id = "";
            this.formData.microgrid_catalog_iname = "";
            this.formData.microgrid_catalog_type = "";
        },
        handleEditInfo(row, title) {
            this.dialogStatus = true;
            this.dialogTitle = title;
            this.formData = { ...row };
        },
        addCommit() {
            this.$refs["formData"].validate(valid => {
                if (valid) {
                    api.saveCatalog({ ...this.formData }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getAreaPriceList();
                        }
                        this.dialogStatus = false;
                    });
                }
            });
        },
        hanleDelInfo(row) {
            this.$confirm("确定删除这条数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deleteCatalog({
                    area_id: row.area_id
                }).then(res => {
                    if (res && res.error_code === "0") {
                        // 最后一页，只有一条数据时，点击删除
                        if (
                            this.totalNum -
                                (this.pageNum - 1) * this.pageSize ==
                            1
                        ) {
                            // 处理页码显示问题
                            this.pageNum =
                                this.pageNum == 1
                                    ? this.pageNum
                                    : this.pageNum - 1;
                        }
                        this.getAreaPriceList();
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                    }
                });
            });
        },
        getRandom(min,max){
            return Math.floor(Math.random() * (max - min + 1) + min);
        },
        handleEditDJ(row) {
            this.curRow = row;
            this.expressionList = row.infos;
            if (this.expressionList.length == 0) {
                this.curIndex = this.oldCurIndex = 0;
                this.doAddDate(0);
            } else {
                this.expressionList.forEach(item => {
                    item.microgrid_catalog_price_id = item.area_id + this.getRandom(1000000, 0)
                });
                this.curIndex = this.oldCurIndex = this.expressionList[0].microgrid_catalog_price_id;
                this.djForm.capacity_price = this.expressionList[0].capacity_price;
                this.djForm.demand_price = this.expressionList[0].demand_price;
                this.$forceUpdate();
            }
            this.djDialogStatus = true;
        },
        addMonth(dateStr){
            if(dateStr == null || "" == dateStr){
                return null;
            }
            const date = new Date(dateStr);
            date.setMonth(date.getMonth() + 1);
            return date.toISOString().split('T')[0];
        },
        doAddDate(index) {
            
            let expression = this.expressionList[this.expressionList.length - 1];
            console.log("================"+expression)
            let month = this.addMonth(expression.to_date);
            
            this.expressionList.push({
                microgrid_catalog_price_id: index,
                area_id: this.curRow.area_id,
                area_name: this.curRow.area_name,
                capacity_price: "",
                demand_price: "",
                from_date: month,
                to_date: null,
            });
        },
        changeDateRadio(index) {
            this.expressionList.forEach(item => {
                if (item.microgrid_catalog_price_id == this.oldCurIndex) {
                    item.capacity_price = this.djForm.capacity_price;
                    item.demand_price = this.djForm.demand_price;
                }
            });
            this.oldCurIndex = this.curIndex = index;
            this.expressionList.forEach(item => {
                if (item.microgrid_catalog_price_id == this.curIndex) {
                    this.djForm.capacity_price = item.capacity_price;
                    this.djForm.demand_price = item.demand_price;
                }
            });
        },
        doMinusDate(aa, index) {
            if (this.curIndex == index) {
                this.curIndex -= 1;
            }
            this.expressionList.forEach(item => {
                if (item.microgrid_catalog_price_id == this.curIndex) {
                    this.djForm.capacity_price = item.capacity_price;
                    this.djForm.demand_price = item.demand_price;
                }
            });
            this.expressionList.pop();
        },
        addDjCommit() {
            this.$refs['djForm'].validate(valid => {
                if (valid) {
                    this.expressionList.forEach(item => {
                        if (item.microgrid_catalog_price_id == this.curIndex) {
                            item.capacity_price = this.djForm.capacity_price;
                            item.demand_price = this.djForm.demand_price;
                        }
                        if (
                            item.from_date == "" ||
                            item.from_date == null ||
                            item.to_date == "" ||
                            item.to_date == null
                        ) {
                            this.$message({
                                type: "error",
                                message: "时间不能为空"
                            });
                            return;
                        }
                    });
                    api.savePrice(this.expressionList).then(res => {
                        if (res && res.error_code == 0) {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.getAreaPriceList();
                            this.closeDjDialog();
                        }
                    });
                }
            });
            
        },
        closeDjDialog() {
            this.getAreaPriceList();
            // this.expressionList = []
            // this.djForm.capacity_price = null;
            // this.djForm.demand_price = null;
            // this.djDialogStatus = false;
            this.djDialogStatus = false;
            this.$refs["djForm"].resetFields();
            this.$refs["djForm"].clearValidate();
            // this.$emit("update:dialogVisible", this.dialogVisible);
            // this.$emit("closeCb");
        },
        closeDiaCb() {
            this.dialogStatus = false;
        }
    }
};
</script>
<style lang="scss" scope>
.leader-dialog .el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: auto;
}
</style>
<style lang="scss">
.ww_elec_maintain {
    width: 100%;
    height: 100%;
    padding: px2Rem(20px);
    box-sizing: border-box;
    .caculate-wrap {
        width: 100%;
        height: 400px;
        overflow-y: auto;
        .text-wrap {
            width: 100%;
            min-height: 7rem;
            // @include border;
            border-radius: 6px;
            // @include font-color;
            color: #fff;
            font-size: 1.2rem;
            line-height: 1em;
            padding: 0.6rem;
            box-sizing: border-box;
            margin-top: 1rem;
        }
        .elec_price_btn {
            // margin-left:1rem !important;
            // background-color: #ff6637;
            // border-color: #ff6637;
            // color: #fff;
            box-shadow: inset 0 0 10px #06b4f9,
            inset 0 0 10px #034d5d, inset 0 0 10px #06b4f9,
            inset 0 0 10px #034d5d;
            background: #093c47;
            border-radius: 0.3rem;
            padding: 0 0.9rem;
            span {
                font-size: 1rem;
            }
        }
        .elec_price_btn_minus {
            border: 1px solid #56fbff;
            background: #093c47;
            border-radius: 0.3rem;
            padding: 0 0.9rem;
            span {
                font-size: 1rem;
            }
        }
        .express-btn {
            width: 36rem;
            margin-top: 20px;
            display: flex;
            flex-wrap: wrap;
            margin: 0 auto;
            margin-top: 2rem;
            .express-item {
                margin-right: 1.4rem;
                margin-bottom: 1.6rem;
                width: 4rem;
                height: 4rem;
                background: linear-gradient(-12deg, #171533, #063b7b, #1e1837);
                border: 1px solid #56fcff;
                border-radius: 50%;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                font-size: 1.5rem;
                color: #00e1d4;
                cursor: pointer;
            }
        }
        .btn-wrap {
            width: 36rem;
            margin: 0 auto;
            margin-top: 1rem;
            .btn-inner-wrap {
                display: inline-flex;
                margin-left: 2rem;
            }
            .btn-clear,
            .btn-save {
                width: 8.5rem;
                height: 2.2rem;
                line-height: 2.2rem;
                text-align: center;
                font-size: 1rem;
                color: #fff;
                border-radius: 0.3rem;
                cursor: pointer;
            }
            .btn-clear {
                background: #8e9eab;
                border: 1px solid #3d3d3d;
                margin-right: 5rem;
            }
            .btn-save {
                background: linear-gradient(-12deg, #073775, #5c0991);
                border: 1px solid #3d3d3d;
            }
        }
        .point_date {
            display: inline-flex;
            align-items: center;
            margin-top: 0.3rem;
            width: 100%;
            padding-top: 0.3rem;
            box-sizing: border-box;
        }
    }
}
</style>
